import type { ReactNode } from "react";
import { UserLanguageProvider, useUserLanguage } from "./context";

type FlowLanguageScopeProps = {
  language: string;
  children: ReactNode;
};

/**
 * QL-597 — renders flow content in the flow's language inside the advisor UI.
 * Widgets read `useUserLanguage()`, which is the advisor's own language
 * everywhere else, so the wizard wraps page content in this scope. The tenant
 * defaults come from the parent provider. `key` resets the provider's state
 * when the flow language changes.
 */
export function FlowLanguageScope({ language, children }: FlowLanguageScopeProps) {
  const { tenantDefaultLanguage, tenantSupportedLanguages } = useUserLanguage();
  return (
    <UserLanguageProvider
      key={language}
      userLanguage={language}
      tenantDefaultLanguage={tenantDefaultLanguage}
      tenantSupportedLanguages={tenantSupportedLanguages}
    >
      {children}
    </UserLanguageProvider>
  );
}
